<div class="flex row y-content-start y-items-start lotto-box-cont" *ngIf="lottoId != 11">
  <div class="square-lotto">
    <h3 class="lotto-box txt-left full-height light-2 uppercase flat-{{ 'logoFlat' | translate }}">
      <figure>
        <div class="circle offer-circle">
          <strong class="uppercase">
            <span class="nxn-offer">{{lotto.offer.multiplier}}X{{lotto.offer.base}}</span>
          </strong>
        </div>
        <div class="logo-box-{{system}}">
          <app-logo-lotto></app-logo-lotto>
        </div>
      </figure>
    </h3>
  </div>
  <div class="square-date square-jackpot">
    <h4 class="light-2 letter-spacing--05">
      <app-jackpot></app-jackpot>
    </h4>
  </div>
</div>

<div class="flex column y-items-center lotto-box-cont" *ngIf="lottoId == 11">
  <div class="promo-3d">
    <img src="https://d3tmfelegj51yl.cloudfront.net/landings/nxnoffer/img/promo/3x2-christmas.png" alt="" />
  </div>

  <div class="jackpot-present flex y-items-end">
    <div class="logo-box-{{system}}">
      <app-logo-lotto></app-logo-lotto>
    </div>
    <h4 class="light-2 letter-spacing--05">
      <app-jackpot></app-jackpot>
    </h4>
  </div>
</div>
